import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicResetPassword({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8.03.72a7.28 7.28 0 11-4.97 12.6.3.3 0 010-.42l.67-.67c.17-.16.32-.04.4.03a5.78 5.78 0 10-1.2-7l.77.01c.17 0 .3.13.3.3v.8a.3.3 0 01-.3.3H.3v-3.4c0-.17.13-.3.3-.3h.8c.17 0 .3.13.3.3V4.4A7.28 7.28 0 018.03.72zM8 3.27a2.7 2.7 0 012.7 2.53v1.09c.51.08.9.5.9 1v2.96c0 .56-.5 1.02-1.1 1.02h-5c-.6 0-1.1-.46-1.1-1.02V7.9c0-.5.39-.92.9-1v-.92c0-1.5 1.2-2.7 2.7-2.7zm2.2 5H5.8v2.2h4.4v-2.2zM8 4.67a1.3 1.3 0 00-1.3 1.17v1.03h2.6v-.9c0-.72-.58-1.3-1.3-1.3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicResetPassword.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicResetPassword.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicResetPassword svgRef={ref} {...props} />
));
export default ForwardRef;
